var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.921509,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#004087"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4909 16.6963L18.9044 14.1103H16.422V12.3C16.422 11.5759 16.6805 11.0067 17.8182 11.0067H19.0079V8.62789C18.3352 8.52433 17.6118 8.42151 16.9383 8.42151C14.8181 8.42151 13.3176 9.71482 13.3176 12.0422V14.1111H10.9917V16.697H13.3176V23.2664C14.3416 23.4732 15.3966 23.4732 16.4206 23.2664V16.6984L18.4909 16.6963Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0b56c840e3a45accda62b228a65f3fc8.svg";
export { ForwardRef as ReactComponent };